import React from 'react';
import { useStaticQuery, graphql, Script } from 'gatsby';
import Facebook from './Facebook';
import Locales from './Locales';
import Twitter from './Twitter';
import ZoomInfo from './ZoomInfo';

import UpKeepOGImage from '../../assets/UpKeep_Feature@2x.png';

const SEO = ({
  title,
  indexable = true,
  description,
  imgUrl,
  footerHtml,
  headHtml,
  pathname,
  pageType,
  mainEntity,
  datePublished,
  dateModified,
  schema = [],
}) => {
  const { site, locales } = useStaticQuery(query);
  const activeLanguage = pathname?.includes('/es/') ? 'es' : 'en';

  const {
    siteMetadata: {
      siteUrl,
      defaultTitle,
      defaultDescription,
      siteLanguage,
      ogLanguage,
      author: siteAuthor,
      twitter,
      facebook,
    },
  } = site;

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    imgUrl: imgUrl || UpKeepOGImage,
    url: `${siteUrl}${pathname || ''}`,
  };

  const defaultSchema = {
    '@context': 'http://schema.org',
    '@type': pageType || 'WebPage',
    url: seo.url,
    inLanguage: siteLanguage,
    mainEntityOfPage: seo.url,
    mainEntity: mainEntity || [],
    description: seo.description,
    name: seo.title,
    datePublished,
    dateModified,
    author: {
      '@type': 'Organization',
      name: siteAuthor,
    },
    copyrightHolder: {
      '@type': 'Organization',
      name: siteAuthor,
    },
    copyrightYear: new Date().getFullYear(),
    creator: {
      '@type': 'Organization',
      name: siteAuthor,
    },
    publisher: {
      '@type': 'Organization',
      name: siteAuthor,
    },
    image: {
      '@type': 'ImageObject',
      url: seo.imgUrl,
    },
  };

  const structuredData = [
    defaultSchema,
    ...(Array.isArray(schema) ? schema : [schema]),
  ].filter(Boolean);

  return (
    <>
      <html lang={activeLanguage || 'en'} />
      <title>{seo.title}</title>
      <Locales url={seo.url} locales={locales.nodes} />
      <Script
        src="https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script="5bf3431b-ebeb-48d9-9e40-a28bd08e856f"
      />
      <Script type="text/javascript">{`function OptanonWrapper() { }`}</Script>
      <ZoomInfo />
      <meta
        name="google-site-verification"
        content="q_TAfZGqwDyUfV4iXOyEBt3xaCcACq1cijbb_TSc-Nk"
      />
      <meta
        name="facebook-domain-verification"
        content="o9f2rhzlbau1fpvzdlin1ltaqfdzu0"
      />
      {seo.title && <meta name="title" content={seo.title} />}
      {seo.description && <meta name="description" content={seo.description} />}
      {!indexable && <meta name="robots" content="noindex, nofollow" />}
      {seo.url && <link rel="canonical" href={seo.url} />}
      {headHtml && headHtml}
      {footerHtml && footerHtml}
      {structuredData.map((schemaItem, index) => (
        <Script key={index} type="application/ld+json">
          {JSON.stringify(schemaItem)}
        </Script>
      ))}
      <Facebook
        description={seo.description}
        image={seo.imgUrl}
        title={seo.title}
        url={seo.url}
        locale={ogLanguage}
        name={facebook}
      />
      <Twitter
        title={seo.title}
        image={seo.imgUrl}
        description={seo.description}
        username={twitter}
      />
    </>
  );
};

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        siteUrl
        defaultTitle: title
        defaultDescription: description
        siteLanguage
        ogLanguage
        author
        twitter
        facebook
      }
    }
    locales: allLocale {
      nodes {
        ns
        language
      }
    }
  }
`;

export default SEO;
